// extracted by mini-css-extract-plugin
export default {"productOpportunityWrapper":"styles_productOpportunityWrapper__lnGm3","titleContainer":"styles_titleContainer__JxQwg","listWrapper":"styles_listWrapper__9Bfmu"};